import {
  ArrowBack as ArrowBackIcon,
  Assignment as AssignmentIcon,
  CloudUpload as CloudUploadIcon,
  InsertDriveFile as FileIcon,
  Refresh as RefreshIcon,
  Schedule as ScheduleIcon,
  Send as SendIcon,
} from "@mui/icons-material";
import CommentIcon from "@mui/icons-material/Comment";
import {
  Alert,
  Badge,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Chip,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  LinearProgress,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ComentariosDeUmDocumento from "../components/ComentariosDeUmDocumento";
import PagamentosSection, {
  PAPEL_EMPREENDEDOR,
} from "../components/PagamentosSection";
import PdfOpenActionConfirmDialog from "../components/PdfOpenActionConfirmDialog";
import SolicitarPublicacaoModal from "../components/SolicitarPublicacaoModal";
import StatusChip from "../components/StatusChip";
import RamaPanel from "../components/RamaPanel";
import api from "../services/api";
import licencasService from "../services/licencas";
import licencaEmitidaService from "../services/licencaEmitida";
import publicacaoService from "../services/publicacao";
import {
  statusLabelsEnum,
  mascaraStatusEmpreendedor,
  statusPublicacaoLabels,
  statusPublicacaoEnum,
} from "../utils/constants";
import { obterCategoriaDocumento } from "../utils/categoriaDocumento";
import {
  abrirDocumentoArquivo,
  documentoEstaEnviado,
} from "../utils/abrirDocumentoArquivo";
import {
  getMuiChipColor,
  getPublicacaoPaletteKey,
} from "../utils/statusPalette";
import { sxBlocoComentario } from "../utils/sxBlocoComentario";
import { formatDateToShow } from "../utils/formatters";
import { getApiErrorMessage } from "../utils/getApiErrorMessage";
import {
  UPLOAD_PRESETS,
  validateUploadFile,
} from "../utils/validateUploadFile";

const normalizarNomeDocumento = (nome) => {
  if (!nome) return "";

  let normalizado = nome.toLowerCase();

  normalizado = normalizado.replace(/[^\w\s]/g, " ");

  normalizado = normalizado.replace(
    /(checklist|documento de|doc\.|documento|arquivo)/g,
    "",
  );

  normalizado = normalizado.replace(/\s+/g, " ").trim();

  return normalizado;
};

function DetalheSolicitacao() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [solicitacao, setSolicitacao] = useState(null);
  const [downloadingLicenca, setDownloadingLicenca] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
  const [documentoSelecionado, setDocumentoSelecionado] = useState(null);
  const [novoDocumento, setNovoDocumento] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState("");
  const [openActionDialog, setOpenActionDialog] = useState({
    open: false,
    message: "",
    errors: [],
  });

  // eslint-disable-next-line no-unused-vars
  const [isProprietario, setIsProprietario] = useState(true);
  const [comentarioDialogOpen, setComentarioDialogOpen] = useState(false);
  const [processoSelecionado, setProcessoSelecionado] = useState(null);
  const [
    condicionanteComentarioDialogOpen,
    setCondicionanteComentarioDialogOpen,
  ] = useState(false);
  const [
    condicionanteSelecionadoParaComentario,
    setCondicionanteSelecionadoParaComentario,
  ] = useState(null);

  const [
    uploadComprovantePagamentoDialogOpen,
    setUploadComprovantePagamentoDialogOpen,
  ] = useState(false);
  const [comprovantePagamento, setComprovantePagamento] = useState(null);
  const [uploadComprovanteError, setUploadComprovanteError] = useState("");

  const [condicionantes, setCondicionantes] = useState([]);
  const [loadingCondicionantes, setLoadingCondicionantes] = useState(false);
  const [
    responderCondicionanteDialogOpen,
    setResponderCondicionanteDialogOpen,
  ] = useState(false);
  const [condicionanteSelecionado, setCondicionanteSelecionado] =
    useState(null);
  const [respostaCondicionante, setRespostaCondicionante] = useState(null);
  const [respostaCondicionanteDescricao, setRespostaCondicionanteDescricao] =
    useState("");
  const [uploadingRespostaCondicionante, setUploadingRespostaCondicionante] =
    useState(false);
  const [respostaCondicionanteError, setRespostaCondicionanteError] =
    useState("");

  const [documentosSolicitacao, setDocumentosSolicitacao] = useState([]);
  const [publicacaoSite, setPublicacaoSite] = useState(null);
  const [solicitarPublicacaoOpen, setSolicitarPublicacaoOpen] = useState(false);

  const carregarCondicionantes = async () => {
    try {
      setLoadingCondicionantes(true);
      const response = await api.get(`/Condicionante/solicitacao/${id}`);

      if (response.data && response.data.data) {
        setCondicionantes(response.data.data);
      } else {
        setCondicionantes([]);
      }
    } catch (error) {
      setCondicionantes([]);
    } finally {
      setLoadingCondicionantes(false);
    }
  };
//TODO VALIDAR ISSO
  const handleDownloadLicenca = async () => {
    setDownloadingLicenca(true);
    try {
      const response = await licencaEmitidaService.obterPorSolicitacaoDeLicencaId(solicitacao.id);
      const licencaData = response.data;
      let blob;
      if (typeof licencaData.fileContent === "string") {
        const byteCharacters = atob(licencaData.fileContent);
        const byteArray = new Uint8Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteArray[i] = byteCharacters.charCodeAt(i);
        }
        blob = new Blob([byteArray], { type: licencaData.contextType || "application/pdf" });
      } else {
        blob = new Blob([new Uint8Array(licencaData.fileContent)], { type: licencaData.contextType || "application/pdf" });
      }
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = licencaData.fileName || "licenca.pdf";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(() => window.URL.revokeObjectURL(url), 30000);
    } catch (error) {
      console.error("Erro ao baixar a licença:", error);
      alert("Erro ao baixar a licença. Tente novamente.");
    } finally {
      setDownloadingLicenca(false);
    }
  };

  const carregarSolicitacao = async (id) => {
    try {
      const data = await licencasService.obterSolicitacao(id);

      const documentos = await obterTodosDocumentos(data.id);

      setDocumentosSolicitacao(documentos);

      setSolicitacao(data);
      await carregarCondicionantes();
      try {
        const pub = await publicacaoService.obterPorSolicitacao(data.id);
        setPublicacaoSite(pub);
      } catch {
        setPublicacaoSite(null);
      }
    } catch (err) {
      setError("Erro desconhecido ao carregar a solicitação");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    carregarSolicitacao(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (solicitacao?.id) {
      carregarCondicionantes();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [solicitacao?.id]);

  const obterTodosDocumentos = async (idDaSolicitacao) => {
    try {
      const response = await api.get(
        `/Documento/solicitacao/${idDaSolicitacao}`,
      );

      if (response.data && response.data.data) {
        return response.data.data;
      }

      return [];
    } catch (error) {
      return [];
    }
  };

  const handleAbrirComentarioDialog = (doc, processo) => {
    setDocumentoSelecionado(doc);
    setProcessoSelecionado(processo);
    setComentarioDialogOpen(true);
  };

  const handleFecharComentarioDialog = () => {
    setComentarioDialogOpen(false);
    setDocumentoSelecionado(null);
    setProcessoSelecionado(null);
  };

  const handleAbrirCondicionanteComentarioDialog = (condicionante) => {
    setCondicionanteSelecionadoParaComentario(condicionante);
    setCondicionanteComentarioDialogOpen(true);
  };

  const handleFecharCondicionanteComentarioDialog = () => {
    setCondicionanteComentarioDialogOpen(false);
    setCondicionanteSelecionadoParaComentario(null);
  };

  const renderComentarios = (doc) => {
    const nomeDocNormalizado = normalizarNomeDocumento(doc.nome);

    if (solicitacao.comentarios && Array.isArray(solicitacao.comentarios)) {
      const comentarios = solicitacao.comentarios.filter((c) => {
        const nomeComentarioNormalizado = normalizarNomeDocumento(
          c.nome_documento,
        );

        const matchExato = c.nome_documento === doc.nome;

        const matchNormalizado =
          nomeDocNormalizado === nomeComentarioNormalizado;

        const nomeDocLowerCase = doc.nome.toLowerCase();
        const nomeComentarioLowerCase = c.nome_documento.toLowerCase();
        const matchParcial =
          nomeDocLowerCase.includes(nomeComentarioLowerCase) ||
          nomeComentarioLowerCase.includes(nomeDocLowerCase) ||
          nomeDocNormalizado.includes(nomeComentarioNormalizado) ||
          nomeComentarioNormalizado.includes(nomeDocNormalizado);

        return matchExato || matchNormalizado || matchParcial;
      });

      if (comentarios.length > 0) {
        return comentarios.map((comentario, index) => (
          <Box key={index} sx={sxBlocoComentario(solicitacao.status)}>
            <Typography variant="body2" fontWeight="medium">
              <strong>Comentário:</strong> {comentario.comentario}
            </Typography>
            <Typography variant="caption">
              {new Date(comentario.data_criacao).toLocaleString()}
            </Typography>
          </Box>
        ));
      } else {
        return null;
      }
    }

    if (solicitacao.analise && solicitacao.analise.comentarios) {
      const comentarios = solicitacao.analise.comentarios.filter((c) => {
        const nomeComentarioNormalizado = normalizarNomeDocumento(
          c.nome_documento,
        );

        const matchExato = c.nome_documento === doc.nome;

        const matchNormalizado =
          nomeDocNormalizado === nomeComentarioNormalizado;

        const nomeDocLowerCase = doc.nome.toLowerCase();
        const nomeComentarioLowerCase = c.nome_documento.toLowerCase();
        const matchParcial =
          nomeDocLowerCase.includes(nomeComentarioLowerCase) ||
          nomeComentarioLowerCase.includes(nomeDocLowerCase) ||
          nomeDocNormalizado.includes(nomeComentarioNormalizado) ||
          nomeComentarioNormalizado.includes(nomeDocNormalizado);

        return matchExato || matchNormalizado || matchParcial;
      });

      if (comentarios.length > 0) {
        return comentarios.map((comentario, index) => (
          <Box key={index} sx={sxBlocoComentario(solicitacao.status)}>
            <Typography variant="body2" fontWeight="medium">
              <strong>Comentário do Analista:</strong> {comentario.comentario}
            </Typography>
            <Typography variant="caption">
              {new Date(comentario.data_criacao).toLocaleString()}
            </Typography>
          </Box>
        ));
      } else {
        return null;
      }
    }

    return null;
  };

  const handleFecharUploadDialog = () => {
    setUploadDialogOpen(false);
    setDocumentoSelecionado(null);
    setNovoDocumento(null);
    setUploadError("");
    setOpenActionDialog({ open: false, message: "", errors: [] });
  };

  const handleFileChange = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    event.target.value = "";

    const resultado = await validateUploadFile(file, UPLOAD_PRESETS.documento);
    if (!resultado.valid) {
      setUploadError(resultado.error);
      setNovoDocumento(null);
      return;
    }

    setUploadError("");
    setNovoDocumento(file);
  };

  const montarFormDataUploadDocumento = (removerOpenAction = false) => {
    const formData = new FormData();
    formData.append("solicitacaoDeLicencaId", solicitacao.id);
    formData.append("documentoId", documentoSelecionado.id);

    const nomeLimpo = documentoSelecionado.nome
      .replace(/^📄 /, "")
      .replace(/ \[ .* \]$/, "");

    const extensao = novoDocumento.name.slice(
      novoDocumento.name.lastIndexOf("."),
    );
    const nomeDocumentoFormatado = nomeLimpo + extensao;

    const arquivoComNovoNome = new File(
      [novoDocumento],
      nomeDocumentoFormatado,
      {
        type: novoDocumento.type,
      },
    );

    formData.append("arquivo", arquivoComNovoNome);

    if (removerOpenAction) {
      formData.append("removerOpenAction", "true");
    }

    return formData;
  };

  const finalizarUploadDocumentoComSucesso = async () => {
    const documentosAtualizados = await obterTodosDocumentos(solicitacao.id);
    setDocumentosSolicitacao(documentosAtualizados);
    handleFecharUploadDialog();
    alert("Documento enviado com sucesso!");
  };

  const handleEnviarDocumento = async () => {
    try {
      if (!novoDocumento || !documentoSelecionado) {
        setUploadError("Selecione um arquivo para enviar");
        return;
      }

      if (uploading || openActionDialog.open) {
        return;
      }

      setUploading(true);
      setUploadError("");

      const formData = montarFormDataUploadDocumento(false);
      const response = await api.post(
        "Documento/UploadDeDocumentoSolicitado",
        formData,
      );

      if (response.status === 200 || response.status === 201) {
        await finalizarUploadDocumentoComSucesso();
      }
    } catch (error) {
      const errorBody = error.response?.data;
      if (errorBody?.type === "pdf_open_action_detected") {
        setOpenActionDialog({
          open: true,
          message: errorBody.message || "",
          errors: Array.isArray(errorBody.errors) ? errorBody.errors : [],
        });
        return;
      }

      const mensagemErro =
        errorBody?.message ||
        errorBody?.detail ||
        error.message ||
        "Erro ao enviar documento. Tente novamente.";
      setUploadError(mensagemErro);
    } finally {
      setUploading(false);
    }
  };

  const handleConfirmarOpenAction = async () => {
    if (!novoDocumento || !documentoSelecionado) {
      setOpenActionDialog({ open: false, message: "", errors: [] });
      setUploadError("Selecione um arquivo para enviar");
      return;
    }

    setUploading(true);
    setUploadError("");
    try {
      const formData = montarFormDataUploadDocumento(true);
      const response = await api.post(
        "Documento/UploadDeDocumentoSolicitado",
        formData,
      );

      setOpenActionDialog({ open: false, message: "", errors: [] });

      if (response.status === 200 || response.status === 201) {
        await finalizarUploadDocumentoComSucesso();
      }
    } catch (error) {
      setOpenActionDialog({ open: false, message: "", errors: [] });
      const errorBody = error.response?.data;
      if (errorBody?.type === "pdf_open_action_detected") {
        setOpenActionDialog({
          open: true,
          message: errorBody.message || "",
          errors: Array.isArray(errorBody.errors) ? errorBody.errors : [],
        });
        return;
      }

      const mensagemErro =
        errorBody?.message ||
        errorBody?.detail ||
        error.message ||
        "Erro ao enviar documento. Tente novamente.";
      setUploadError(mensagemErro);
    } finally {
      setUploading(false);
    }
  };

  const handleCancelarOpenAction = () => {
    setOpenActionDialog({ open: false, message: "", errors: [] });
    setUploadError(
      "O documento não será enviado enquanto o PDF com abertura automática não tiver a remoção autorizada.",
    );
  };

  const handleAbrirUploadComprovante = () => {
    setUploadComprovantePagamentoDialogOpen(true);
  };

  const handleFecharUploadComprovante = () => {
    setUploadComprovantePagamentoDialogOpen(false);
    setComprovantePagamento(null);
    setUploadComprovanteError("");
  };

  const handleComprovantePagamentoChange = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    event.target.value = "";

    const resultado = await validateUploadFile(file, UPLOAD_PRESETS.pagamento);
    if (!resultado.valid) {
      setUploadComprovanteError(resultado.error);
      setComprovantePagamento(null);
      return;
    }

    setUploadComprovanteError("");
    setComprovantePagamento(file);
  };

  const handleEnviarComprovantePagamento = async () => {
    try {
      if (!comprovantePagamento) {
        setError("Selecione um arquivo como comprovante de pagamento");
        return;
      }

      setLoading(true);
      setError(null);

      await licencasService.enviarComprovantePagamento(
        solicitacao.id,
        comprovantePagamento,
        solicitacao.tipo_licenca,
        solicitacao.subtipo_licenca,
      );

      await carregarSolicitacao();

      setUploadComprovantePagamentoDialogOpen(false);
      setComprovantePagamento(null);
      setUploadComprovanteError("");
    } catch (error) {
      if (error.detail) {
        setError(error.detail);
      } else if (typeof error === "string") {
        setError(error);
      } else if (error.documento_pagamento) {
        setError(`Erro no documento: ${error.documento_pagamento[0]}`);
      } else {
        setError(
          "Ocorreu um erro ao enviar o comprovante de pagamento. Tente novamente.",
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const handleAbrirResponderCondicionante = (condicionante) => {
    setCondicionanteSelecionado(condicionante);
    setRespostaCondicionante(null);
    setRespostaCondicionanteDescricao("");
    setRespostaCondicionanteError("");
    setResponderCondicionanteDialogOpen(true);
  };

  const handleFecharResponderCondicionante = () => {
    setResponderCondicionanteDialogOpen(false);
  };

  const handleRespostaCondicionanteChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    event.target.value = "";

    const resultado = await validateUploadFile(file, UPLOAD_PRESETS.condicionante);
    if (!resultado.valid) {
      setRespostaCondicionanteError(resultado.error);
      return;
    }

    setRespostaCondicionante(file);
    setRespostaCondicionanteError("");

    if (!respostaCondicionanteDescricao) {
      const fileName = file.name.replace(/\.[^/.]+$/, "");
      const formattedName = fileName
        .replace(/[-_]+/g, " ")
        .replace(/([a-z])([A-Z])/g, "$1 $2")
        .replace(/\b\w/g, (l) => l.toUpperCase());

      setRespostaCondicionanteDescricao(formattedName);
    }
  };

  const handleEnviarRespostaCondicionante = async () => {
    if (!respostaCondicionante || !condicionanteSelecionado) {
      setRespostaCondicionanteError("Selecione um arquivo para enviar.");
      return;
    }

    setUploadingRespostaCondicionante(true);
    setRespostaCondicionanteError("");

    try {
      const nomeCondicionante = condicionanteSelecionado.fileName;
      const extensao = respostaCondicionante.name.substring(
        respostaCondicionante.name.lastIndexOf("."),
      );
      const nomeComExtensao = nomeCondicionante.endsWith(extensao)
        ? nomeCondicionante
        : nomeCondicionante + extensao;

      const arquivoRenomeado = new File(
        [respostaCondicionante],
        nomeComExtensao,
        { type: respostaCondicionante.type },
      );

      const formData = new FormData();
      formData.append("solicitacaoDeLicencaId", solicitacao.id);
      formData.append("condicionanteId", condicionanteSelecionado.id);
      formData.append("arquivo", arquivoRenomeado);

      const response = await api.post(
        "Condicionante/EnviarCondicionante",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (response.status === 200) {
        setRespostaCondicionante(null);
        setRespostaCondicionanteDescricao("");
        setRespostaCondicionanteError("");
        handleFecharResponderCondicionante();
        await carregarCondicionantes();
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Erro ao enviar a resposta. Tente novamente.";
      setRespostaCondicionanteError(errorMessage);
    } finally {
      setUploadingRespostaCondicionante(false);
    }
  };

  const renderCondicionantes = () => {
    if (loadingCondicionantes) {
      return (
        <Box sx={{ p: 2, textAlign: "center" }}>
          <CircularProgress size={24} />
          <Typography variant="body2" sx={{ mt: 1 }}>
            Carregando condicionantes...
          </Typography>
        </Box>
      );
    }

    if (condicionantes.length === 0) {
      try {
        const cachedCondicionantes = localStorage.getItem(
          `condicionantes_${id}`,
        );
        if (cachedCondicionantes) {
          const parsedCondicionantes = JSON.parse(cachedCondicionantes);
          if (
            Array.isArray(parsedCondicionantes) &&
            parsedCondicionantes.length > 0
          ) {
            setCondicionantes(parsedCondicionantes);
          }
        }
      } catch (err) {}
    }

    if (condicionantes.length === 0) {
      return (
        <Box sx={{ p: 2, textAlign: "center" }}>
          <Typography variant="body2" color="text.secondary">
            Não há condicionantes para esta solicitação.
          </Typography>
          <Button
            variant="outlined"
            color="primary"
            size="small"
            onClick={carregarCondicionantes}
            startIcon={<RefreshIcon />}
            sx={{ mt: 2 }}
          >
            Atualizar Condicionantes
          </Button>
        </Box>
      );
    }

    return (
      <Box>
        <Box
          sx={{
            mb: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" component="h2">
            Documentos Condicionantes
          </Typography>
        </Box>

        {condicionantes.map((condicionante) => {
          const isPendente =
            condicionante.status === statusLabelsEnum.ANALISTA_ANALISANDO;
          const statusText = isPendente ? "Pendente" : "Atendido";
          const badgeColor = isPendente ? "warning" : "success";

          let arquivoUrl = null;
          if (!isPendente && condicionante.conteudo) {
            const mimeType = condicionante.contextType || "application/pdf";
            const byteCharacters = atob(condicionante.conteudo);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: mimeType });
            arquivoUrl = URL.createObjectURL(blob);
          }

          return (
            <Card
              key={condicionante.id}
              sx={{
                mb: 2,
                border: 2,
                borderColor: isPendente ? "warning.main" : "success.main",
                position: "relative",
                boxShadow: !isPendente ? 3 : 1,
              }}
            >
              <CardContent>
                <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
                  <Badge color={badgeColor}>
                    <AssignmentIcon sx={{ mr: 1 }} />
                  </Badge>
                  <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                    {condicionante.fileName || "Documento Condicionante"}
                  </Typography>
                  <Chip
                    size="small"
                    label={statusText}
                    color={badgeColor}
                    variant="outlined"
                  />
                </Box>

                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 1.5 }}
                >
                  <strong>Instruções:</strong>{" "}
                  {condicionante.instrucoes || "Nenhuma instrução adicional."}
                </Typography>

                {condicionante.prazoParaResposta && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      mb: 1.5,
                      color: "text.secondary",
                    }}
                  >
                    <ScheduleIcon fontSize="small" sx={{ mr: 0.5 }} />
                    <Typography variant="body2">
                      <strong>Prazo:</strong>{" "}
                      {new Date(
                        condicionante.prazoParaResposta,
                      ).toLocaleDateString("pt-BR")}
                    </Typography>
                  </Box>
                )}
              </CardContent>

              <CardActions
                sx={{
                  px: 2,
                  pb: 2,
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: { xs: "stretch", sm: "center" },
                  gap: 1,
                }}
              >
                {isPendente && isProprietario && (
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    fullWidth
                    startIcon={<SendIcon />}
                    onClick={() =>
                      handleAbrirResponderCondicionante(condicionante)
                    }
                    sx={{ width: { xs: "100%", sm: "auto" } }}
                  >
                    Responder Condicionante
                  </Button>
                )}

                {!isPendente && arquivoUrl && (
                  <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                    <Button
                      href={arquivoUrl}
                      target="_blank"
                      size="small"
                      variant="outlined"
                      color="success"
                      startIcon={<FileIcon />}
                    >
                      Visualizar Resposta
                    </Button>
                    <Tooltip title="Ver comentários">
                      <IconButton
                        size="small"
                        aria-label="Ver comentários"
                        onClick={() =>
                          handleAbrirCondicionanteComentarioDialog(
                            condicionante,
                          )
                        }
                      >
                        <Badge
                          badgeContent={condicionante.hasMessages ? "!" : 0}
                          color="error"
                        >
                          <CommentIcon fontSize="small" />
                        </Badge>
                      </IconButton>
                    </Tooltip>
                  </Box>
                )}

                {isPendente && (
                  <Tooltip title="Ver comentários">
                    <IconButton
                      size="small"
                      aria-label="Ver comentários"
                      onClick={() =>
                        handleAbrirCondicionanteComentarioDialog(condicionante)
                      }
                    >
                      <Badge
                        badgeContent={condicionante.hasMessages ? "!" : 0}
                        color="error"
                      >
                        <CommentIcon fontSize="small" />
                      </Badge>
                    </IconButton>
                  </Tooltip>
                )}
              </CardActions>
            </Card>
          );
        })}
      </Box>
    );
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!solicitacao) {
    return (
      <Container>
        <Box sx={{ mt: 4 }}>
          <Alert severity="error">Solicitação não encontrada</Alert>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
      <Box sx={{ mt: 4, mb: 4 }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate("/minhas-solicitacoes")}
          sx={{ mb: 2 }}
        >
          Voltar
        </Button>

        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          sx={{ fontSize: { xs: "1.1rem", md: "1.5rem" } }}
        >
          Detalhes da Solicitação
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <Paper sx={{ p: { xs: 2, sm: 3 }, mb: 3 }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={8}>
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 1,
                  alignItems: "center",
                }}
              >
                <Typography variant="h6">
                  {solicitacao.nomeTipoLicenca}
                </Typography>
                <StatusChip
                  status={mascaraStatusEmpreendedor(solicitacao.status)}
                />
              </Box>
              <Divider sx={{ my: 2 }} />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <Typography variant="subtitle2" color="textSecondary">
                Data da Solicitação
              </Typography>
              <Typography variant="body1">
                {formatDateToShow(solicitacao.createAt)}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <Typography variant="subtitle2" color="textSecondary">
                Empreendimento
              </Typography>
              <Typography variant="body1">
                {solicitacao.empreendimento?.nome || "—"}
              </Typography>
            </Grid>

            {solicitacao.numeroProtocolo && (
              <Grid item xs={12} sm={6} md={4}>
                <Typography variant="subtitle2" color="textSecondary">
                  Número do Protocolo
                </Typography>
                <Typography variant="body1">
                  {solicitacao.numeroProtocolo}
                </Typography>
              </Grid>
            )}

            {solicitacao.numeroDaLicenca && (
              <Grid item xs={12} sm={6} md={4}>
                <Typography variant="subtitle2" color="textSecondary">
                  Número da Licença
                </Typography>
                <Typography variant="body1">
                  {solicitacao.numeroDaLicenca}
                </Typography>
              </Grid>
            )}

            <Grid item xs={12} sm={6} md={4}>
              <Typography variant="subtitle2" color="textSecondary">
                Área Total
              </Typography>
              <Typography variant="body1">
                {solicitacao.areaTotal} m²
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="subtitle2" color="textSecondary">
                Descrição do Projeto
              </Typography>
              <Typography variant="body1">
                {solicitacao.descricaoDoProjeto}
              </Typography>
            </Grid>
          </Grid>
        </Paper>

        <Paper sx={{ p: { xs: 2, sm: 3 }, mb: 3 }}>
          <Typography variant="h6" sx={{ mb: 1 }}>
            Publicação de recebimento de licença
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Solicite a publicação de recebimento desta licença na aba pública de
            Publicações.
          </Typography>
          {!publicacaoSite ? (
            <Button
              variant="contained"
              onClick={() => setSolicitarPublicacaoOpen(true)}
            >
              Solicitar publicação de recebimento
            </Button>
          ) : (
            <Box>
              <Chip
                label={statusPublicacaoLabels[publicacaoSite.status] ?? publicacaoSite.status}
                color={getMuiChipColor(getPublicacaoPaletteKey(publicacaoSite.status))}
                sx={{ mb: 2 }}
              />
              {publicacaoSite.isAgricultorFamiliarOuBaixaRenda && (
                <Typography variant="body2" sx={{ mb: 1 }}>
                  Agricultor familiar / baixa renda: Sim
                </Typography>
              )}
              {publicacaoSite.status !== statusPublicacaoEnum.PUBLICADA && (
                <PagamentosSection
                  solicitacao={{ id: publicacaoSite.id }}
                  papel={PAPEL_EMPREENDEDOR}
                />
              )}
            </Box>
          )}
        </Paper>

        <SolicitarPublicacaoModal
          open={solicitarPublicacaoOpen}
          onClose={() => setSolicitarPublicacaoOpen(false)}
          solicitacaoDeLicencaId={solicitacao.id}
          onSucesso={(data) => setPublicacaoSite(data)}
        />

        {solicitacao.status === statusLabelsEnum.LICENCA_ASSINADA && (
          <Paper
            elevation={1}
            sx={{
              p: 3,
              mb: 3,
              bgcolor: "success.light",
              border: 1,
              borderColor: "success.main",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <FileIcon sx={{ color: "success.main", mr: 1, fontSize: 30 }} />
              <Typography variant="h6" color="success.dark">
                Licença Ambiental Emitida
              </Typography>
            </Box>
            <Typography variant="body1" sx={{ mb: 2 }}>
              O documento oficial da sua licença ambiental está disponível para
              download.
            </Typography>
            <Button
              variant="contained"
              color="success"
              onClick={handleDownloadLicenca}
              disabled={downloadingLicenca}
              fullWidth
              startIcon={downloadingLicenca ? <CircularProgress size={18} color="inherit" /> : <FileIcon />}
              sx={{ borderRadius: 2, width: { xs: "100%", sm: "auto" } }}
            >
              {downloadingLicenca ? "Carregando..." : "Visualizar/Baixar Licença"}
            </Button>
          </Paper>
        )}

        {(solicitacao.status === statusLabelsEnum.LICENCA_EMITIDA ||
          solicitacao.status === statusLabelsEnum.LICENCA_ASSINADA) && (
          <Paper elevation={1} sx={{ p: 3, mb: 3 }}>
            <RamaPanel
              solicitacaoId={solicitacao.id}
              papel="interessado"
              licencaEmitida
            />
          </Paper>
        )}

        {solicitacao.status === "AGUARDANDO_PAGAMENTO" && (
          <Paper
            elevation={1}
            sx={{
              p: { xs: 2, sm: 3 },
              mb: 3,
              bgcolor: "info.light",
              border: 1,
              borderColor: "info.main",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              <FileIcon sx={{ color: "info.main", mr: 1, fontSize: 30 }} />
              <Typography variant="h6" color="info.dark">
                Documento de Pagamento
              </Typography>
            </Box>

            {solicitacao.documento_pagamento ||
            solicitacao.documento_pagamento_analista ? (
              <>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  O documento de pagamento para análise da sua licença está
                  disponível para download.
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  href={
                    solicitacao.documento_pagamento ||
                    solicitacao.documento_pagamento_analista
                  }
                  target="_blank"
                  fullWidth
                  startIcon={<FileIcon />}
                  sx={{
                    borderRadius: 2,
                    mr: { sm: 2 },
                    mb: { xs: 1, sm: 0 },
                    width: { xs: "100%", sm: "auto" },
                  }}
                >
                  Visualizar/Baixar Documento de Pagamento
                </Button>
              </>
            ) : (
              <Typography variant="body1" sx={{ mb: 2 }}>
                Nenhum documento de pagamento disponível no momento.
              </Typography>
            )}

            <Box
              sx={{ mt: 3, pt: 3, borderTop: 1, borderStyle: "dashed", borderColor: "divider" }}
            >
              <Typography variant="subtitle1" gutterBottom>
                Enviar Comprovante de Pagamento
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Por favor, envie o comprovante de pagamento para prosseguir com
                sua solicitação.
              </Typography>

              {solicitacao.comprovante_pagamento_enviado ? (
                <Alert severity="success" sx={{ mb: 2 }}>
                  Comprovante de pagamento já enviado. Aguardando análise.
                </Alert>
              ) : (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  {isProprietario && (
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      startIcon={<CloudUploadIcon />}
                      onClick={() => handleAbrirUploadComprovante()}
                      sx={{ borderRadius: 2, width: { xs: "100%", sm: "auto" } }}
                    >
                      Enviar Comprovante
                    </Button>
                  )}
                </Box>
              )}
            </Box>
          </Paper>
        )}

        <Paper sx={{ p: { xs: 2, sm: 3 }, mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            Documentos da Licença
          </Typography>
          <List dense>
            {(() => {
              const documentosProcessados = new Set();
              const documentosUnicos = [];
              const adicionarDocumentoUnico = (doc) => {
                if (!documentosProcessados.has(doc.nome)) {
                  documentosProcessados.add(doc.nome);
                  documentosUnicos.push(doc);
                  return true;
                }
                return false;
              };
              if (
                documentosSolicitacao &&
                Array.isArray(documentosSolicitacao)
              ) {
                documentosSolicitacao.forEach((doc, index) => {
                  const documento = {
                    id: doc.data,
                    nome: doc.fileName,
                    campo: `solicitacao_${doc.data || index}`,
                    enviado: documentoEstaEnviado(doc.status),
                    tamanho: doc.sizeBytes,
                    tipo: doc.contextType,
                    dataCriacao: doc.createAt,
                    solicitacao: true,
                    status: doc.status,
                    message: doc.message,
                    descricao: doc.descricao,
                    hasMessages: doc.hasMessages,
                  };

                  adicionarDocumentoUnico(documento);
                });
              }

              return documentosUnicos.map((doc, index) => {
                const categoria = obterCategoriaDocumento(doc.campo, doc.enviado);
                return (
                <ListItem
                  key={`doc-${index}`}
                  sx={{
                    borderLeft: categoria ? "4px solid" : "none",
                    borderLeftColor: categoria?.borderColor,
                    mb: 1,
                    borderRadius: 1,
                  }}
                >
                  <ListItemIcon>
                    {categoria ? (
                      <Badge color={categoria.badgeColor} variant="dot">
                        <FileIcon role="img" aria-label={categoria.ariaLabel} />
                      </Badge>
                    ) : (
                      <FileIcon />
                    )}
                  </ListItemIcon>
                  <ListItemText
                    component="div"
                    secondaryTypographyProps={{ component: "div" }}
                    primary={
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          flexWrap: "wrap",
                          gap: 1,
                        }}
                      >
                        <Typography component="span">{doc.nome}</Typography>
                        {categoria && (
                          <>
                            <Chip
                              size="small"
                              label={categoria.label}
                              color={categoria.chipColor}
                              variant="outlined"
                              sx={{ height: 20, fontSize: "0.7rem" }}
                            />
                            <Chip
                              size="small"
                              label={categoria.statusLabel}
                              color={categoria.statusColor}
                              variant="outlined"
                              sx={{ height: 20, fontSize: "0.7rem" }}
                            />
                          </>
                        )}
                      </Box>
                    }
                    secondary={
                      <Box>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            flexWrap: "wrap",
                            mb: 1,
                            gap: 1,
                          }}
                        >
                          {doc.enviado ? (
                            <>
                              <Button
                                size="small"
                                variant="outlined"
                                color="primary"
                                startIcon={<FileIcon />}
                                sx={{ mt: 0.5 }}
                                onClick={async () => {
                                  try {
                                    await abrirDocumentoArquivo(doc.id);
                                  } catch (error) {
                                    alert(
                                      getApiErrorMessage(
                                        error,
                                        "Não foi possível abrir o documento.",
                                      ),
                                    );
                                  }
                                }}
                              >
                                VISUALIZAR
                              </Button>
                              <Tooltip title="Adicionar comentário">
                                <IconButton
                                  size="small"
                                  aria-label="Adicionar comentário"
                                  onClick={() =>
                                    handleAbrirComentarioDialog(
                                      doc,
                                      solicitacao,
                                    )
                                  }
                                >
                                  <Badge
                                    badgeContent={doc.hasMessages ? "!" : 0}
                                    color="error"
                                  >
                                    <CommentIcon />
                                  </Badge>
                                </IconButton>
                              </Tooltip>
                            </>
                          ) : (
                            <>
                              {solicitacao.status ===
                                statusLabelsEnum.SOLICITANDO_INFORMACOES &&
                                !doc.campo.startsWith("analista_") &&
                                isProprietario && (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: 1,
                                    }}
                                  >
                                    <Button
                                      variant="contained"
                                      component="span"
                                      color="warning"
                                      startIcon={<CloudUploadIcon />}
                                      size="small"
                                      sx={{ mt: 0.5 }}
                                      onClick={() => {
                                        setDocumentoSelecionado(doc);
                                        setUploadError("");
                                        setNovoDocumento(null);
                                        setUploadDialogOpen(true);
                                      }}
                                    >
                                      Selecionar
                                    </Button>
                                  </Box>
                                )}

                              {solicitacao.status ===
                                statusLabelsEnum.SOLICITANDO_INFORMACOES && (
                                <Typography
                                  variant="body2"
                                  color="text.secondary"
                                >
                                  Este documento foi solicitado pelo analista
                                  posteriormente. {doc.descricao}
                                </Typography>
                              )}
                            </>
                          )}
                        </Box>
                        {renderComentarios(doc)}
                      </Box>
                    }
                  />
                </ListItem>
                );
              });
            })()}
          </List>
        </Paper>

        <Paper sx={{ p: { xs: 2, sm: 3 }, mt: 3 }}>
          <Typography
            variant="h5"
            gutterBottom
            sx={{
              display: "flex",
              alignItems: "center",
              fontSize: { xs: "1.1rem", md: "1.5rem" },
            }}
          >
            <AssignmentIcon sx={{ mr: 1 }} />
            Documentos Condicionantes
          </Typography>
          <Divider sx={{ mb: 2 }} />

          <Typography variant="body2" color="text.secondary" paragraph>
            Documentos condicionantes requerem que você envie uma resposta. O
            analista avaliará sua resposta e poderá aprová-la ou solicitar novas
            informações.
          </Typography>

          {renderCondicionantes()}
        </Paper>

        <Paper sx={{ p: { xs: 2, sm: 3 }, mt: 3 }}>
          <PagamentosSection
            solicitacao={solicitacao}
            papel={PAPEL_EMPREENDEDOR}
          />
        </Paper>
      </Box>

      <Dialog
        open={uploadDialogOpen}
        onClose={handleFecharUploadDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>{"Reenviar Documento"}</DialogTitle>
        <DialogContent>
          <Typography variant="h6" gutterBottom>
            {documentoSelecionado?.nome}
          </Typography>

          {documentoSelecionado?.campo?.startsWith("checklist_") && (
            <Alert severity="info" sx={{ mb: 2 }}>
              Este é um documento do checklist. Ao reenviar, você está
              substituindo a versão anterior por uma versão atualizada.
            </Alert>
          )}

          {documentoSelecionado?.campo?.startsWith("analista_") && (
            <Alert severity="info" sx={{ mb: 2 }}>
              Este é um documento enviado pelo analista. Ao reenviar, você está
              substituindo a versão anterior por uma versão atualizada.
            </Alert>
          )}

          {uploadError && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {uploadError}
            </Alert>
          )}

          <Box sx={{ mt: 2 }}>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Formatos aceitos: PDF ou PNG. Tamanho máximo: 10 MB.
            </Typography>

            <input
              type="file"
              onChange={handleFileChange}
              style={{ display: "none" }}
              id="arquivo-input"
              accept=".pdf,.png"
            />
            <label htmlFor="arquivo-input">
              <Button
                variant="outlined"
                component="span"
                startIcon={<CloudUploadIcon />}
                disabled={uploading}
                fullWidth
                sx={{ mb: 2 }}
              >
                Selecionar Arquivo
              </Button>
            </label>

            {novoDocumento && (
              <>
                <Alert severity="warning" sx={{ mb: 2 }}>
                  O documento <strong>{novoDocumento.name}</strong> será
                  vinculado ao arquivo{" "}
                  <strong>{documentoSelecionado?.nome}</strong>
                </Alert>
                <Paper
                  variant="outlined"
                  sx={{ p: 2, mt: 2, bgcolor: "background.default" }}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <FileIcon color="primary" sx={{ mr: 1 }} />
                    <Box>
                      <Typography variant="subtitle2">
                        {novoDocumento.name}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {(novoDocumento.size / 1024).toFixed(2)} KB -{" "}
                        {novoDocumento.type}
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
              </>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleFecharUploadDialog} disabled={uploading}>
            Cancelar
          </Button>
          <Button
            onClick={handleEnviarDocumento}
            variant="contained"
            color="primary"
            disabled={!novoDocumento || uploading || openActionDialog.open}
            startIcon={
              uploading ? <CircularProgress size={20} /> : <CloudUploadIcon />
            }
          >
            {uploading ? "Enviando..." : "Enviar Documento"}
          </Button>
        </DialogActions>
      </Dialog>

      <PdfOpenActionConfirmDialog
        open={openActionDialog.open}
        message={openActionDialog.message}
        errors={openActionDialog.errors}
        onConfirm={handleConfirmarOpenAction}
        onCancel={handleCancelarOpenAction}
        loading={uploading}
      />

      <Dialog
        open={uploadComprovantePagamentoDialogOpen}
        onClose={handleFecharUploadComprovante}
      >
        <DialogTitle>Enviar Comprovante de Pagamento</DialogTitle>
        <DialogContent>
          <Typography variant="body1" gutterBottom>
            Faça o upload do seu comprovante de pagamento
          </Typography>

          {uploadComprovanteError && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {uploadComprovanteError}
            </Alert>
          )}

          <Box sx={{ mt: 2 }}>
            <input
              type="file"
              onChange={handleComprovantePagamentoChange}
              style={{ display: "none" }}
              id="comprovante-input"
              accept=".pdf,.jpg,.jpeg,.png"
            />
            <label htmlFor="comprovante-input">
              <Button
                variant="outlined"
                component="span"
                startIcon={<CloudUploadIcon />}
                disabled={uploading}
              >
                Selecionar Arquivo
              </Button>
            </label>
            {comprovantePagamento && (
              <Typography variant="body2" sx={{ mt: 1 }}>
                Arquivo selecionado: {comprovantePagamento.name}
              </Typography>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleFecharUploadComprovante} disabled={uploading}>
            Cancelar
          </Button>
          <Button
            onClick={handleEnviarComprovantePagamento}
            variant="contained"
            color="primary"
            disabled={!comprovantePagamento || uploading}
          >
            {uploading ? <CircularProgress size={24} /> : "Enviar Comprovante"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={responderCondicionanteDialogOpen}
        onClose={handleFecharResponderCondicionante}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Responder ao Condicionante</DialogTitle>
        <DialogContent>
          <Typography variant="h6" gutterBottom>
            {condicionanteSelecionado?.fileName || "Documento Condicionante"}
          </Typography>

          <Alert severity="info" sx={{ mb: 2, alignItems: "center" }}>
            <Typography variant="body2">
              <strong>Instruções:</strong>{" "}
              {condicionanteSelecionado?.instrucoes ||
                "Nenhuma instrução adicional."}
            </Typography>
          </Alert>

          {respostaCondicionanteError && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {respostaCondicionanteError}
            </Alert>
          )}

          <Box sx={{ mt: 2 }}>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Formatos aceitos: PDF ou PNG. Tamanho máximo: 10 MB.
            </Typography>

            <input
              type="file"
              onChange={handleRespostaCondicionanteChange}
              style={{ display: "none" }}
              id="resposta-condicionante-input"
              accept=".pdf,.png"
            />
            <label htmlFor="resposta-condicionante-input">
              <Button
                variant="outlined"
                component="span"
                startIcon={<CloudUploadIcon />}
                disabled={uploadingRespostaCondicionante}
                fullWidth
                sx={{ mb: 2 }}
              >
                Selecionar Arquivo
              </Button>
            </label>

            {respostaCondicionante && (
              <Paper
                variant="outlined"
                sx={{ p: 2, mt: 2, bgcolor: "background.default" }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <FileIcon color="primary" sx={{ mr: 1 }} />
                  <Box>
                    <Typography variant="subtitle2">
                      {respostaCondicionante.name}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {(respostaCondicionante.size / 1024 / 1024).toFixed(2)} MB
                      - {respostaCondicionante.type}
                    </Typography>
                  </Box>
                </Box>
              </Paper>
            )}
          </Box>

          {uploadingRespostaCondicionante && (
            <Box sx={{ width: "100%", mt: 2 }}>
              <LinearProgress />
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleFecharResponderCondicionante}
            disabled={uploadingRespostaCondicionante}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleEnviarRespostaCondicionante}
            variant="contained"
            color="primary"
            disabled={uploadingRespostaCondicionante || !respostaCondicionante}
            startIcon={
              uploadingRespostaCondicionante ? (
                <CircularProgress size={20} />
              ) : (
                <SendIcon />
              )
            }
          >
            {uploadingRespostaCondicionante ? "Enviando..." : "Enviar Resposta"}
          </Button>
        </DialogActions>
      </Dialog>

      <ComentariosDeUmDocumento
        open={comentarioDialogOpen}
        onClose={handleFecharComentarioDialog}
        documento={documentoSelecionado}
        processo={processoSelecionado}
        onComentarioSalvo={() => carregarSolicitacao(id)}
      />

      <ComentariosDeUmDocumento
        open={condicionanteComentarioDialogOpen}
        onClose={handleFecharCondicionanteComentarioDialog}
        documento={condicionanteSelecionadoParaComentario}
        processo={solicitacao}
        onComentarioSalvo={() => carregarCondicionantes()}
        tipoRecurso="condicionantes"
      />
    </Container>
  );
}

export default DetalheSolicitacao;
